import { render, staticRenderFns } from "./club-teams-list.vue?vue&type=template&id=423d3736&scoped=true"
import script from "./club-teams-list.vue?vue&type=script&lang=js"
export * from "./club-teams-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423d3736",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/projects/subsapp-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('423d3736')) {
      api.createRecord('423d3736', component.options)
    } else {
      api.reload('423d3736', component.options)
    }
    module.hot.accept("./club-teams-list.vue?vue&type=template&id=423d3736&scoped=true", function () {
      api.rerender('423d3736', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/club-teams/club-teams-list.vue"
export default component.exports